import { Component, inject } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { TeamsService } from "./core/teams.service";
import { PwaService } from "./core/services/pwa-service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  standalone: true,
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  private translate = inject(TranslateService);
  private pwa = inject(PwaService);
  title = "web";

  constructor(private router: Router) {
  // LANGUAGE
    const storedLang = localStorage.getItem("language");
    const defaultLang = "pt-BR";
    const selectedLang = storedLang || defaultLang;
    const teamsService = inject(TeamsService);

    this.pwa.checkUserAgent();

window.addEventListener('focus', () => {
  this.pwa.trackStandalone();
});


      window.addEventListener('beforeinstallprompt', (e: any) => {
        e.preventDefault();

        this.pwa.promptIntercepted = true;
        this.pwa.deferredPrompt = e;
        this.pwa.promptSaved = true;

      });

      window.addEventListener('appinstalled', () => {
        this.pwa.trackInstalled();
      });

    this.translate.addLangs(["pt-BR", "en-US"]);
    this.translate.use(selectedLang);
    this.translate.setFallbackLang(selectedLang);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const elementMain = document.getElementById("mainPage");
        if (elementMain) {
          elementMain.scrollTo(0, 0);
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        console.log("[TEAMS] ROUTE EVENTS", event.urlAfterRedirects);
        console.log("[TEAMS] Verify isTeams:", teamsService.isTeams());

        // if (teamsService.isTeams() && event.urlAfterRedirects !== "/") {
        //   sessionStorage.setItem("lastRoute", event.urlAfterRedirects);
        //   console.log("[TEAMS] Saved route:", event.urlAfterRedirects);
        // }

        if (teamsService.isTeams() && event.urlAfterRedirects !== "/") {
          const currentRoute = sessionStorage.getItem("currentRoute");

          if (currentRoute && currentRoute !== event.urlAfterRedirects) {
            sessionStorage.setItem("previousRoute", currentRoute);
            console.log("[TEAMS] Previous route:", currentRoute);
          }

          sessionStorage.setItem("currentRoute", event.urlAfterRedirects);

          sessionStorage.setItem("lastRoute", event.urlAfterRedirects);
          console.log("[TEAMS] Last route:", event.urlAfterRedirects);
        }
      });

    // this.router.events.subscribe((event) => {
    //   console.log("[TEAMS] Router Events", new Date().toISOString());

    //   if (event instanceof NavigationEnd) {
    //     if (isTeams()) {
    //       console.log("[TEAMS] OpenTeams", new Date().toISOString());
    //       sessionStorage.setItem("lastRoute", event.urlAfterRedirects);
    //       console.log("[TEAMS] Set Session", event.urlAfterRedirects);
    //     }
    //   }
    // });
  }
}

// export class AppComponent {
//   private translate = inject(TranslateService);

//   constructor(private router: Router) {
//     // language (ok)
//     const storedLang = localStorage.getItem("language");
//     const selectedLang = storedLang || "pt-BR";

//     this.translate.addLangs(["pt-BR", "en-US"]);
//     this.translate.use(selectedLang);
//     this.translate.setFallbackLang(selectedLang);

//     this.router.events
//       .pipe(
//         filter(
//           (event): event is NavigationEnd => event instanceof NavigationEnd
//         )
//       )
//       .subscribe((event) => {
//         // scroll
//         document.documentElement.scrollTop = 0;
//         document.body.scrollTop = 0;

//         // salvar rota apenas no Teams e se NÃO for root
//         if (isTeams() && event.urlAfterRedirects !== "/") {
//           sessionStorage.setItem("lastRoute", event.urlAfterRedirects);
//           console.log("[TEAMS] Saved route:", event.urlAfterRedirects);
//         }
//       });
//   }
// }
